import { render, staticRenderFns } from "./ScreenCapture.vue?vue&type=template&id=76c96294"
import script from "./ScreenCapture.vue?vue&type=script&lang=js"
export * from "./ScreenCapture.vue?vue&type=script&lang=js"
import style0 from "./ScreenCapture.vue?vue&type=style&index=0&id=76c96294&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports